import React from 'react';
import { SortDir } from '@fabric-ui/components';
import { emptyObject } from '@fabric-ui/utils';
import { Box, SxProps } from '@mui/material';
import { useAvContext } from '../../../context/AvContextProvider';

interface TopKDisplayProps {
  metric: string;
  top: number;
  dir: SortDir;
  style?: SxProps;
}

const TopKDisplay = ({ metric, top, dir, style = emptyObject }: TopKDisplayProps) => {
  const { measurements } = useAvContext();
  return (
    <Box sx={{ fontSize: 12, ...style }}>
      <b>{`${dir === SortDir.DESC ? 'Top' : 'Bottom'} ${top} `}</b>
      {`by ${measurements.asObject[metric]?.displayName || metric}`}
    </Box>
  );
};

export default TopKDisplay;
